/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SendPatientSignatureRequestMessage from 'DesignSystem/SendPatientSignatureRequestMessage/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/Contracts/Content/Payor/Content/SignAction/Empty/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'id',
})
let patientPersonIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'person.id',
})
let constantData = ' '
let onSubmit = fromHelpers.useOnSubmit({
  children,
  viewPath
  
})
let onSubmitPre = fromHelpers.useOnSubmitPre({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<SendPatientSignatureRequestMessage
  viewPath={`${viewPath}/SendPatientSignatureRequestMessage`}
 data="patient.id"
 patientId={patientIdValueData}
 data="patient.person.id"
 personId={patientPersonIdValueData}
 onSubmit={onSubmit}
 onSubmitPre={onSubmitPre}
 data="' '"
 message={constantData}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 includeProfessionals={false}
 includeExternalProfessionals={false}
/>
{children}
</React.Fragment>)
}